import { createContext } from 'react';

export const MapLoadedContext = createContext(false);
